import {tns} from '../../../../node_modules/tiny-slider/src/tiny-slider';
import SliderPhotoContent from '../../utils/SliderPhotoContent';
import App from '../../App';
import DraggableArea from '../../utils/DraggableArea';

'use strict'

class Home{
    constructor(){
        //console.log('Home');

        //this._modalHack = document.getElementById('modal_hack');
        //this._modalHackClose = this._modalHack.querySelector('.close_btn');
        //this._modalHackClose.addEventListener('click', (e) => {
        //    e.preventDefault();
        //    e.stopPropagation();
        //
        //    this._modalHack.classList.remove('modal--show', 'modal--anim');
        //});

        document.getElementById('header').classList.remove('header--white');

        this._sliderTestimonials = new SliderPhotoContent(document.getElementById('slider_testimonials'));
        this._sliderNews = new SliderPhotoContent(document.getElementById('slider_news'));

        this.video_contents = document.querySelectorAll('.home-video');
        this.video_contents.forEach(function(content){
            let video = content.querySelectorAll('.video__play')[0];
            content.addEventListener('click', (e)=>{
                e.preventDefault();
                App.modalVideo.show(video.getAttribute('data-source'), 'video-url').showControls().unMute();
            });
        })
        

        
        // Slider team
        this._sliderTeam = tns({
            container: '#slider_team',
            nav: false,
            controls: false,
            mouseDrag: true,
            edgePadding: 30,
            speed: 600,
            autoplayButtonOutput: false,
            slideBy: 1,
            preventScrollOnTouch: 'auto',
            preventActionWhenRunning: true,
            items: 1,
            loop: true,
            responsive: {
                540: {
                    items: 2,
                },
                768: {
                    items: 3,
                },
                992: {
                    mouseDrag: false,
                    edgePadding: 0,
                    items: 2,
                },
                1366: {
                    items: 3,
                },
            }
        });

        this._sliderTeam.events.on('indexChanged', (slider) => {
            //console.log('indexChanged:', this._sliderTeam.getInfo());
            //console.log('indexChanged:', slider);
            let items = document.getElementById('slider_team').querySelectorAll('.tns-slide-active');
            items.forEach(function(content){
                let current_selected_img = content.querySelector('.bg__img');
                let image_src = current_selected_img.getAttribute('data-src');
                if(current_selected_img.style.backgroundImage === ''){
                    current_selected_img.style.backgroundImage = "url('" + image_src + "')";
                }
            })
            
        }); 

        // Slider team btn next
        document.getElementById('slider_team_btn_next').addEventListener('click', (e)=>{
            e.preventDefault();

            this._sliderTeam.goTo('next');
        });

        // Slider recognitions
        this._sliderRecognitions = tns({
            container: '#slider_recognitions',
            nav: false,
            controls: false,
            mouseDrag: true,
            speed: 600,
            autoplayButtonOutput: false,
            slideBy: 1,
            center: true,
            preventScrollOnTouch: 'auto',
            preventActionWhenRunning: true,
            items: 1,
            edgePadding: 15,
            loop: true,
            onInit: () => {
                if(window.innerWidth < 768){
                    document.querySelectorAll('#slider_recognitions .tns-slide-active')[0].classList.add('slider-carousel__item--current');
                }else{
                    document.querySelectorAll('#slider_recognitions .tns-slide-active')[1].classList.add('slider-carousel__item--current');
                }
            },
            responsive: {
                375: {
                    edgePadding: 30,
                },
                540: {
                    edgePadding: 0,
                    items: 2,
                },
                768: {
                    items: 3,
                },
                992: {
                        edgePadding: 0,
                },
            }
        });

        this._sliderRecognitions.events.on('indexChanged', function(slider) {
            let currentItem = document.querySelector('#slider_recognitions .slider-carousel__item--current');
            
            if(currentItem){
                currentItem.classList.remove('slider-carousel__item--current');
            }
            
            if(window.innerWidth < 768){
                document.querySelectorAll('#slider_recognitions .tns-slide-active')[0].classList.add('slider-carousel__item--current');
            }else{
                document.querySelectorAll('#slider_recognitions .tns-slide-active')[1].classList.add('slider-carousel__item--current');
            }
        });     
        
        //this._draggableAreaAreas = new DraggableArea(document.getElementById('areas_draggable_area'));

        // Slider practices mobile
        
        this._sliderPracticesMobile = tns({
            container: '#slider_practices_mobile',
            nav: false,
            controls: false,
            mouseDrag: true,
            speed: 600,
            autoplayButtonOutput: false,
            slideBy: 1,
            center: false,
            preventScrollOnTouch: 'auto',
            preventActionWhenRunning: true,
            items: 1,
            loop: true,
            edgePadding: 35,
            onInit: (e) => {
                let pager = document.querySelector('.section_practices .slider-pager');
                pager.children[1].innerHTML = ("00" + e.slideCount).slice(-2);    
                
                if (window.innerWidth < 992) {
                    document.querySelectorAll('#slider_practices_mobile .tns-slide-active')[1].classList.add('slider-carousel__item--current');
                }
            },
            responsive: {
                375: {
                    // edgePadding: 75,
                    edgePadding: 60,
                },
                420: {
                    edgePadding: 50,
                },
                540: {
                    edgePadding: 0,
                    items: 2,
                },
                768: {
                    autoWidth: false,
                    edgePadding: 0,
                    items: 3,
                    slideBy: 1
                },
                992: {
                    items: 8
                },
                1440: {
                    items: 8
                }
            }
        });


        this._sliderPracticesMobile.events.on('indexChanged', (e) => {

            let pager = document.querySelector('.section_practices .slider-pager');
            pager.children[0].innerHTML = ("00" + e.displayIndex).slice(-2);
            
            let currentMobile = document.querySelector('#slider_practices_mobile .slider-carousel__item--current');
            
            if(currentMobile){
                currentMobile.classList.remove('slider-carousel__item--current');
            }
            
            document.querySelectorAll('#slider_practices_mobile .tns-slide-active')[1].classList.add('slider-carousel__item--current');
            
        });  
        
        this.draggable_area__content = document.getElementById('areas_draggable_area').querySelector('.draggable-area__content');

        // Card colors info hover on click mobile
        let cardsAreas = document.querySelectorAll('.card-colored--info-hover');
        Array.from(cardsAreas).forEach((cardInfo, i)=>{
            cardInfo.addEventListener('click', this._onClickCardInfo.bind(this));
        })
        
        document.querySelector('.scroll-down').addEventListener('click', this._onClickScrollDownBtn.bind(this));
        document.querySelector('.home-video').addEventListener('click', this._onClickJoinUsVideoBtn.bind(this))
    }

    _onClickCardInfo(e){
        if(window.innerWidth < 992) {
            e.currentTarget.classList.toggle('card-colored--info-hover-tapped');
        }
    }

    _onClickScrollDownBtn(e){
        App.scrollbar.scrollTo(0, document.querySelector('.section_about').offsetTop, 1150);
    }

    _onClickJoinUsVideoBtn(e){
        e.preventDefault();
        //console.log('ENTROOOOO', e.target);

        App.modalVideo.show(App.baseUrl + 'public/video/placeholder-city.mp4');
    }
}

export default Home;